import { useState, useEffect } from 'react';
import { useApp } from '../App';
import api from '../api';

const GENRO_URL = 'https://genro.ai';

function genroEditUrl(binding) {
  if (binding.genro_site_id) {
    return `${GENRO_URL}/sites/${binding.genro_site_id}`;
  }
  if (binding.genro_site_subdomain) {
    return `${GENRO_URL}?site=${binding.genro_site_subdomain}`;
  }
  return GENRO_URL;
}

function openUrl(url) {
  try {
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch {
    window.location.href = url;
  }
}

export default function GenroEntry() {
  const { setPage } = useApp();
  const [bindings, setBindings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/site-bindings/my')
      .then(r => setBindings((r.data || []).filter(b => b.genro_site_id || b.genro_site_subdomain)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const hasGenroSites = bindings.length > 0;

  return (
    <div>
      <div className="page-header">Genro AI</div>

      <div className="card" style={{ marginBottom: 12 }}>
        <div style={{ opacity: 0.85, lineHeight: 1.5 }}>
          Genro AI handles content creation and site generation. Workify CRM handles accounting,
          legalization, and company processing.
        </div>
      </div>

      {!loading && hasGenroSites && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600, marginBottom: 8, opacity: 0.75, fontSize: 13, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            Your Genro sites
          </div>
          {bindings.map(b => (
            <div
              key={b.id}
              className="card"
              style={{ marginBottom: 8, background: 'rgba(255,255,255,0.05)', borderRadius: 12, padding: 14 }}
            >
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                {b.site_name || b.genro_site_subdomain || b.domain}
              </div>
              <div style={{ fontSize: 13, opacity: 0.65, marginBottom: 10, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                {b.domain && <span>{b.domain}</span>}
                {b.genro_site_status && (
                  <span style={{ color: b.genro_site_status === 'published' ? '#4ade80' : '#facc15' }}>
                    ● {b.genro_site_status}
                  </span>
                )}
              </div>
              <button
                className="btn btn-primary"
                style={{ width: '100%' }}
                onClick={() => openUrl(genroEditUrl(b))}
              >
                Edit in Genro AI
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="card">
        <div style={{ display: 'grid', gap: 10 }}>
          <button className="btn btn-primary" onClick={() => openUrl(GENRO_URL)}>
            {hasGenroSites ? 'Create new site in Genro AI' : 'Open Genro AI'}
          </button>
          <button className="btn" onClick={() => setPage('dashboard')}>
            Process in Workify CRM
          </button>
        </div>
      </div>
    </div>
  );
}
